export const limitUnicodeString = (str: string, length: number): string =>
  [...str].slice(0, length).join('');
